export default __webpack_public_path__ + "static/media/head01_ja_pc.29c3791f.png";